import {Checkboxes} from "nhsuk-react-components";
import React, {useId} from "react";

export type CheckboxGroupProp = {
    id: string;
    body: string;
    value: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
};

export type CheckboxGroupProps = {
    id: string;
    checkboxes: Array<CheckboxGroupProp>;
};

export const CheckboxGroup = ({id, checkboxes}: CheckboxGroupProps) => {
    const componentUniqueId = useId();

    return (
        <Checkboxes id={id}>
            {checkboxes.map((checkbox, index) => {
                // Add index to prevent duplicate id error
                const stableId = `${componentUniqueId}-${checkbox.id}-${index}`;

                return (
                    <div className="nhsuk-checkboxes__item" key={checkbox.id || index}>
                        <input
                            id={stableId}
                            name={checkbox.id}
                            type="checkbox"
                            className="nhsuk-checkboxes__input"
                            defaultChecked={checkbox.value}
                            onChange={checkbox.onChange}
                        />
                        <label
                            className={`nhsuk-label nhsuk-checkboxes__label ${checkbox.value ? "ticked" : ""}`}
                            htmlFor={stableId}
                        >
                            {checkbox.body}
                        </label>
                    </div>
                );
            })}
        </Checkboxes>
    );
};
